"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkTechSettings = checkTechSettings;

var _copyContent = _interopRequireDefault(require("../../data/copyContent"));

var _checks = require("../../checks");

var _formatErrors = _interopRequireDefault(require("../../utilities/formatErrors"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
* Checks Experiment Tech Settings 
*     TDCSExperiment(experimentId: $id) {
        productMinVersion
        productMaxVersion
    }
*/
function checkTechSettings({
  productMinVersion,
  productMaxVersion
}) {
  const {
    techSettings: {
      productMinVersionRequired,
      productMinVersionFormatError,
      productMaxVersionRequired,
      productMaxVersionFormatError
    }
  } = _copyContent.default;
  const checks = {
    productMinVersionRequired: (0, _checks.checkString)(productMinVersion, productMinVersionRequired),
    productMinVersionFormatError: (0, _checks.checkValidVersion)(productMinVersion) ? true : productMinVersionFormatError,
    productMaxVersionRequired: (0, _checks.checkString)(productMaxVersion, productMaxVersionRequired),
    productMaxVersionFormatError: (0, _checks.checkValidVersion)(productMaxVersion) ? true : productMaxVersionFormatError
  };
  const errors = (0, _formatErrors.default)(checks);
  return {
    checks,
    errors
  };
}